export const EVENT_TRACKING = {
  appFeature: 'afya_pay',
  appId: 'iclinic_web',
};
